import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TncConstantsService {

  constructor() { }

  public static RoutingURLConstant = {
    AssignTraining: '/tnc/assign-training',
    GetTnCRequests: 'api/tnc/get/getTnCRequests',
    GetTnCStatus: 'api/tnc/get/getStatus',
    TnCOverview: '/tnc/tnc-overview',
    GetTnCUserProfiles: 'api/tnc/get/getTnCUserProfileData',
  };

  public static TNCNavigation: any = {
    Routes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Assign Training/Certification',
        routeURL: '/tnc/assign-training/',
        isClickable: true
      },
      {
        routeName: 'Training/Certification Overview',
        routeURL: '/tnc/tnc-overview/',
        isClickable: true
      },
      {
        routeName: 'User Profile',
        routeURL: '/tnc/user-profile/',
        isClickable: true
      }
    ],
    InnerRoutes: [
      {
        routeName: 'Home',
        routeURL: '../../home',
        isClickable: true
      },
      {
        routeName: 'Assign Training/Certification',
        routeURL: '/tnc/assign-training/',
        isClickable: true
      },
      {
        routeName: 'Training/Certification Overview',
        routeURL: '/tnc/tnc-overview/',
        isClickable: true
      },
      {
        routeName: 'User Profile',
        routeURL: '/tnc/user-profile/',
        isClickable: true
      }
    ],

    ReportRoutes: [
    ]
  };

  public static TNCGetURL = {
    SaveTnCRequest: 'api/tnc/post/saveTnCRequest',
    GetTnCRequests: 'api/tnc/get/getTnCRequests',
    GetCourseByCourseId: '/api/tnc/get/getCourseByCourseId',
    ExportToExcelTnCCourses: '/api/tnc/get/exportToExcelTnCCourses',
    ExportToTrainingMatrixExcel: '/api/tnc/get/getExportTrainingMatrixExcel',
    DownloadZip: "api/tnc/get/downloadzip",
    SaveTnCStatus: 'api/tnc/post/saveTnCStatus',
    SaveTnCApprovals: 'api/tnc/post/saveTnCApprovals',
    GetTnCParticulars: 'api/tnc/get/getTnCParticulars',
    GetStatus: 'api/tnc/get/getStatus',
    GetTnCConfiguration: 'api/tnc/get/getTnCConfiguration',
    SetCourseReschedule: 'api/tnc/post/setCourseReschedule',
    SaveTNCParticulars: 'api/tnc/post/SaveOrUpdateTNCParticulars',
    getReportiesByManagerId: 'api/tnc/get/getReportiesByManagerId',
    DownloadUserProfilePDF: 'api/tnc/get/downloadUserProfilePdf',
    checkDuplicateTraining: 'api/tnc/get/checkDuplicateTraining'
  };

}
export enum CourseStatus {
  Inprogress = 1,
  PendingForApproval,
  NotComplete,
  Cancel,
  Delete,
  Rejected,
  Complete,
  TrainingRescheduled,
  Cancelled,
  Deleted,
  Expired,
  Draft
}
export enum TrainingsStatus {
  Complete = 1,
  NotComplete,
  Cancel,
  Delete
}
